import Api from '@/services/api';

export default {
  
  list() {
    return Api().get('/archives/list');
  }
}